"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchType = void 0;
/**
 * The type of the branch.
 */
var BranchType;
(function (BranchType) {
    // Starts Normal path, background is the default grey. Represented by `#N`.
    BranchType["Normal"] = "N";
    // Starts Advanced or Professional path, background is blue. Represented by `#E`.
    BranchType["Advanced"] = "E";
    // Starts Expert path, background is purple. Represented by `#M`.
    BranchType["Master"] = "M";
})(BranchType = exports.BranchType || (exports.BranchType = {}));
